<template>
  <v-card class="rounded-xl px-4 py-4" width="600">
    <v-card-text>
      <div class="not-found-page">
        <img class="not-found-page__image" src="@/assets/img/e404.svg" />
        <div class="not-found-page__large-number primary--text">404</div>
        <p class="not-found-page__text">
          Oh, no! Looks like you've stumbled upon the mysterious land of missing
          pages, the notorious Error 404! <br />
          Don't worry, you're not alone on this adventurous quest. Our tech
          wizards are probably playing hide-and-seek with the content, but we'll
          wrangle them back soon!
        </p>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-btn
        depressed
        large
        class="primary"
        style="width: 100%"
        @click="redirect"
      >
        Now, get me back!
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<style lang="scss" scoped>
.not-found-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &__image {
    width: 100%;
    display: block;
  }

  &__large-number {
    font-size: 120px;
    line-height: 150px;
    font-weight: bold;
  }

  &__text {
    text-align: center;
  }
}
</style>
<script>
export default {
  methods: {
    redirect() {
      return this.$router.push({ name: "dashboard" });
    },
  },
};
</script>
